import FeedbackPage from '@/components/FeedbackPage'

export default function WhyFeedbackPage() {
  return <FeedbackPage emoji="🎯" title="pages.onboarding.whyFeedback.title" />
}
